import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";


@Component({
    selector: "tab-restrict-dialog",
    templateUrl: "./tab-restrict-dialog.component.html",
    styleUrls: ['./tab-restrict-dialog.component.scss'],

})
export class TabRestrictDialog {
    isLoaderEnabled: boolean = false;
    currentDisplayLanguage: string = 'en'

    constructor(public dialogRef: MatDialogRef<TabRestrictDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.currentDisplayLanguage = sessionStorage.getItem('currentlanguage');
    }


    ngOnInit() {

    }
    onCancel(): void {
        this.dialogRef.close(null);
    }

    updateValue(event) {
        this.dialogRef.close(event);
    }
    keepEdit() {
        this.dialogRef.close(null);
    }
    discard() {
        this.dialogRef.close('discard');
    }


}